<template>
  <div class="back-stage">
    <header class="title">
      <h1>
        <template v-if="!cId">
          <img src="/static/dataVisual/images/logo.svg" alt="">
          <span>浩邈智慧社区数据可视化平台</span>
        </template>
        <span v-else>{{communityName}}小区数据可视化平台</span>
      </h1>
    </header>
    <main class="main-box">
      <section class="sec-l">
        <ul class="list">
          <li class="list-item user-count">
            <h3>
              <i class="iconfont iconicon_jiantou"></i>
              <template v-if="!cId">注册用户总数趋势</template>
              <template v-else>住户总数趋势</template>
            </h3>
            <div id="userCount"></div>
          </li>
          <li class="list-item incr-tene">
            <h3><i class="iconfont iconicon_jiantou"></i>新增住户趋势图</h3>
            <div class="tenment" id="tenment"></div>
          </li>
          <li class="list-item open-num">
            <h3><i class="iconfont iconicon_jiantou"></i>开门次数趋势图</h3>
            <div class="openNum" id="openNum"></div>
          </li>
        </ul>
      </section>
      <section class="sec-c">
        <ul class="list">
          <li class="list-item real-open">
            <ul class="over-view">
              <li v-for="(item, index) of overViewList" :key="index">
                <p>
                  {{item.title}}
                  <a-tooltip overlayClassName="over-view-tip" v-if="item.title === '认证总数'">
                    <template slot="title">通过小区认证的用户总数，有多套房、多个身份的用户只统计一次</template>
                    <a-icon type="info-circle" />
                  </a-tooltip>
                </p>
                <p><span>{{item.value}}</span> {{item.unit}}</p>
              </li>
            </ul>

            <h3><i class="iconfont iconicon_jiantou"></i>实时开门数据</h3>
            <div id="realOpen"></div>
          </li>
          <li class="list-item user-sort">
            <template v-if="!cId">
              <h3><i class="iconfont iconicon_jiantou"></i>小区用户数统计TOP10</h3>
              <section class="sort-title">
                <p class="head">
                  <span>社区名称</span>
                  <span>业主</span>
                  <span>家属</span>
                  <span>租户</span>
                  <span>总数</span>
                </p>
              </section>
            </template>

            <template v-else>
              <h3><i class="iconfont iconicon_jiantou"></i>单元入住人员统计</h3>
              <section class="sort-title">
                <p class="head">
                  <span>单元名称</span>
                  <span>业主</span>
                  <span>家属</span>
                  <span>租户</span>
                  <span>总数</span>
                </p>
              </section>
            </template>

            <div class="user-sort-list">
              <p v-for="(item, index) of userSort.list" :class="{scroll: userSort.isScroll && index===0}" :key="index">
                <span>{{item.name || item.unit_name}}</span>
                <span>{{item.owners}}</span>
                <span>{{item.families}}</span>
                <span>{{item.tenants}}</span>
                <span>{{item.total}}</span>
              </p>
            </div>
          </li>
        </ul>
      </section>
      <section class="sec-r">
        <ul class="list">
          <li class="weath">
            <div class="now">
              <img class="now-icon" :src="nowWeather.icon" alt="">
              <p><span>{{nowWeather.tmp}}</span> ℃</p>
            </div>
            <div class="date-box">
              <p class="time">{{time}}</p>
              <p class="week">{{dateDetail.week}}</p>
              <p class="date">{{dateDetail.dateTxt}}</p>
            </div>
            <div class="forecast">
              <ul>
                <li class="item" v-for="(item, index) of forecast" :key="index">
                  <img :src="item.icon" alt="">
                  <div class="value">
                    <p>{{item.tmpTxt}}</p>
                    <span>{{item.dayTxt}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <li class="list-item repair" :class="{community: $route.name==='communityVis'}">
            <h3><i class="iconfont iconicon_jiantou"></i>报修统计</h3>
            <div class="tongji iconfont iconicon_tongji"></div>
            <div id="repair"></div>
          </li>

          <template v-if="!cId">
            <li class="pie-box">
              <div class="termin">
                <h3><i class="iconfont iconicon_jiantou"></i>累计终端分布</h3>
                <div id="termin"></div>
              </div>
              <div class="active-user">
                <h3><i class="iconfont iconicon_jiantou"></i>近7日活跃用户占比</h3>
                <div id="active-user"></div>
              </div>
            </li>

            <li class="list-item weekly-num">
              <h3><i class="iconfont iconicon_jiantou"></i>近7日小区开门数统计TOP10</h3>
              <section class="weekly-title">
                <p class="head">
                  <span class="txt">社区名称</span>
                  <span class="txt">总数</span>
                </p>
              </section>
              <div class="weekly-list">
                <p v-for="(item, index) of weekly.list" :class="{scroll: weekly.isScroll && index===0}"  :key="index">
                  <span class="txt">{{item.name}}</span>
                  <span class="txt">{{item.num}}</span>
                </p>
              </div>
            </li>
          </template>

          <template v-else>
            <li class="verify">
              <div>
                <h1>{{userApply}}</h1>
                <p>
                  <img class="household" src="/static/dataVisual/images/icon_zhuhu.svg" alt="">
                  <span>待审核住户申请</span>
                </p>
              </div>
              <div>
                <h1>{{keyApply}}</h1>
                <p>
                  <img class="key" src="/static/dataVisual/images/icon_key.svg" alt="">
                  <span>待审核钥匙申请</span>
                </p>
              </div>
            </li>

            <li class="pie-box" :style="{height: pieHeight}">
              <div class="termin">
                <h3><i class="iconfont iconicon_jiantou"></i>累计终端分布</h3>
                <div id="termin"></div>
              </div>
              <div class="active-user">
                <h3><i class="iconfont iconicon_jiantou"></i>近7日活跃用户占比</h3>
                <div id="active-user"></div>
              </div>
            </li>
          </template>
        </ul>
      </section>
    </main>

    <div class="search-btn" @click="openModal">
      <a-icon type="search" />
    </div>

    <!--选择小区的弹窗-->
    <a-modal
      class="select-community-modal"
      title="搜索小区"
      :visible="visible"
      @cancel="visible=false"
      :width="500"
      :maskClosable="true"
      v-bind="$store.state.modalConfig"
    >
      <a-select
        allowClear
        showSearch
        :filterOption="filterOption"
        dropdownClassName="community-dropdown"
        placeholder="请选择小区">
        <a-select-option @click="selectChange(el)" v-for="(el, index) of communityList" :key="index" :value="el.value">{{el.label}}
        </a-select-option>
      </a-select>

      <template slot="footer">
        <a-button key="submit" type="primary" @click="confirm">搜索</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios';
import mixins from '../js/dataVis_mixin';
import mixin from '../js/mixins';
export default {
  name: 'dataVisual',
  mixins: [mixins, mixin.inputSearch, mixin.fetchSelect],
  data () {
    return {
      visible: false,
      isGetData: true,
      isFirst: true,
      forecastInterv: 0,
      interval: 0,
      weatherKey: 'b98fd0a207ae44c0addb3fa8ff7ef3de', // 公司 key
      weekArr: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],

      // 总数据
      backDataInterval: '',
      weekly: { isScroll: false, interval: {}, list: [] },

      // 单个小区数据
      selectedItem: {},
      communityList: [],
      userApply: 0,
      keyApply: 0,
      communityName: ''
    };
  },
  created () {
    this.realTime();
    this.realTimeInterval();

    this.getForecastData();
    this.forecastUpdate();
    this.getNowWeather();
    this.nowUpdate();
  },
  mounted () {
  },
  methods: {
    reqesetAll () {
      axios.all([this.getCommunityTop(), this.getOpenTop()]).then(axios.spread((acct, perms) => {
        clearInterval(this.userSort.interval);
        clearInterval(this.weekly.interval);
        this.carousel(this.userSort);
        this.carousel(this.weekly);
      }));
    },
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
      this.communitySelect((data) => {
        this.communityList = data;
      }, true);
    },
    /* 选择小区 */
    selectChange (item) {
      this.selectedItem = item;
    },
    /* 关闭对话框 */
    confirm () {
      if (this.routeName === 'communityVis' && this.selectedItem.value) {
        this.communityFun();
        this.publicFun();
      } else {
        this.publicFun();
        this.reqesetAll();// 保证两列轮播同时进行
        this.backDataInterval = setInterval(() => { this.reqesetAll(); }, this.intervalTime());
      }

      let id = this.selectedItem.value;
      let name = this.selectedItem.label;
      window.open(`${location.protocol}//${location.host}/#/communityVis?id=${id}&name=${name}`);
      this.visible = false;
    },
    /* 总后台，小区用户统计前10名 */
    getCommunityTop () {
      this.$get({
        url: '/statistics/community_user_top',
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.userSort.list = data.sort(this.compareFn('total'));
        } else {
          this.userSort.list = [];
        }
      });
    },
    /* 排序方法 */
    compareFn (propertyName) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName];
        var value2 = obj2[propertyName];
        if (value1 < value2) {
          return 1;
        } else if (value1 > value2) {
          return -1;
        } else {
          return 0;
        }
      };
    },
    /* 获取一周开门数据前10名 */
    getOpenTop () {
      this.$get({
        url: '/statistics/community_open_top',
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.weekly.list = data.sort(this.compareFn('num'));
        } else {
          this.weekly.list = [];
        }
      });
    },
    /* 获取审核状态 */
    getVerifyStatus () {
      this.$get({
        url: '/statistics/wait_check_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        this.keyApply = data.key_apply;
        this.userApply = data.householder_apply;
      });
    },
    /* 社区楼栋列表轮播 */
    getBuildData () {
      this.$get({
        url: '/statistics/unit_user_statistics',
        params: {community_id: this.cId},
        config: { timeout: 20000 }
      }).then(({data}) => {
        if (data && data.length) {
          this.userSort.list = data;
          clearInterval(this.userSort.interval);
          this.carousel(this.userSort);
        } else {
          this.userSort.list = [];
          clearInterval(this.userSort.interval);
        }
      });
    },

    /* 3-10天预报 每天更新3次, 分别在8, 11, 18点左右更新 */
    forecastUpdate () {
      this.forecastInterv = (60 - new Date().getMinutes()) * 1000 * 60;
      if (this.isGetData === false) {
        this.forecastInterv = 10 * 1000 * 60;
      }
      let timeArr = [
        {hour: 7, minute: 50},
        {hour: 11, minute: 54},
        {hour: 12, minute: 50}
      ];
      for (let i = 0, len = timeArr.length; i < len; i++) {
        this.changeIsGet(timeArr[i]);
      }
      let forecast = setTimeout(() => {
        this.getForecastData();
        clearTimeout(forecast);
        this.forecastUpdate();
      }, this.forecastInterv);
    },
    changeIsGet (item) {
      let date = new Date();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if (hour === item.hour && minute < item.minute) { // 7点50到8点10，10点50到11点10，17点50到18点10
        this.forecastInterv = (item.minute - minute) * 1000 * 60;
      } else if (hour === item.hour + 1 && minute < 10) {
        this.forecastInterv = (10 - minute) * 1000 * 60;
      }
    },
    /* 获取3天气预报 */
    getForecastData () {
      axios.get('https://free-api.heweather.net/s6/weather/forecast', {
        params: {
          location: 'auto_ip',
          key: this.weatherKey
        }
      }).then((res) => {
        let data = res.data.HeWeather6[0].daily_forecast.slice(0, 3);
        data && data.length ? this.isGetData = true : this.isGetData = false;
        data.forEach((ele, index) => {
          ele.icon = `static/dataVisual/images/weather/${this.getWeatherIcon(ele.cond_code_d)}_s.png`;
          ele.tmpTxt = `${ele.tmp_max}/${ele.tmp_min}℃`;
          if (index === 0) {
            ele.dayTxt = '今天';
          } else {
            ele.dayTxt = this.weekArr[new Date(ele.date).getDay()];
          }
        });

        this.$store.commit('setForecast', data);
      }).catch(() => {
      });
    },
    /* 获取实况天气 */
    getNowWeather () {
      axios.get('https://free-api.heweather.net/s6/weather/now', {
        params: {
          key: this.weatherKey,
          location: 'auto_ip'
        }
      }).then((res) => {
        let HeWeather = res.data.HeWeather6;
        if (HeWeather && HeWeather.length) {
          let data = HeWeather[0].now;
          let date = HeWeather[0].update.loc;
          let dateTxt = date.split(' ')[0].split('-').join('/');
          let week = this.weekArr[new Date(date).getDay()];
          this.$store.commit('setDateDetail', { week, dateTxt });
          data.icon = `/static/dataVisual/images/weather/${this.getWeatherIcon(data.cond_code)}.png`;
          this.$store.commit('setNowWeather', data);
        }
      }).catch(() => {
      });
    },
    /* 实况天气 每小时更新多次 */
    nowUpdate () {
      let nowInterval = setTimeout(() => {
        this.getNowWeather();
        clearTimeout(nowInterval);
        this.nowUpdate();
      }, 1000 * 60 * 20);
    },
    /* 实时时间定时器 */
    realTimeInterval () {
      if (this.isFirst) {
        this.interval = (60 - new Date().getSeconds()) * 1000;
      }
      let realTime = setTimeout(() => {
        this.realTime();
        this.isFirst = false;
        this.interval = 1000 * 60;
        clearTimeout(realTime);
        this.realTimeInterval();
      }, this.interval);
    },
    /* 获取实时时间 */
    realTime () {
      let date = new Date();
      let hour = date.getHours();
      hour = hour < 10 ? `0${hour}` : hour;
      let minute = date.getMinutes();
      minute = minute < 10 ? `0${minute}` : minute;
      this.$store.commit('setTime', `${hour}:${minute}`);
    }
  },
  beforeDestroy () {
    clearInterval(this.userSort.interval);
    clearInterval(this.weekly.interval);
    clearInterval(this.backDataInterval);
    clearInterval(this.actionInterval); // 两页面公用方法的interval
    clearInterval(this.communityInterval);
  }
};
</script>



// WEBPACK FOOTER //
// src/package/dataVisual.vue